import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "antd";
import recommendedListingsEmptyImg from "../../../assets/images/recommended-listings-empty-icons.png";
import "../../../styles/dashboardCardTokens.css";
import "./recommendedListingsCard.css";

const { useBreakpoint } = Grid;

export default function RecommendedListingsCard({ listings: listingsProp }) {
  const listings = listingsProp !== undefined ? listingsProp : [];
  const isEmpty = !Array.isArray(listings) || listings.length === 0;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <section className={`rlCard${isEmpty ? " rlCard--empty" : ""}`} aria-label="Recommended Listings">
      <header className="rlHeader">
        <div className="rlHeaderLeft">
          <h3 className="rlTitle">Recommended Listings</h3>
        </div>
      </header>

      {isEmpty ? (
        <div className="rlEmpty">
          <div className="rlEmptyContent">
            <div className="rlEmptyIconsWrap">
              <img src={recommendedListingsEmptyImg} alt="" className="rlEmptyIconsImg" />
            </div>
            <div className="rlEmptyText">
              <h4 className="rlEmptyTitle">No strong acquisition opportunities yet</h4>
              <p className="rlEmptyDesc">
                We didn&apos;t find any private listings that meet your current pricing, mileage, and demand criteria.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="rlSubhead">Fresh Picks ({listings.length})</div>

          {isMobile ? (
            <div className="rlList rlList--cards">
              {listings.map((x) => {
                const grade = x.grade ?? "B";
                const isHighProfit = grade === "A";
                const CardContent = () => (
                  <>
                    <div className="rlCardTop">
                      <span className={`rlGradeBadge rlGradeBadge--outline rlGradeBadge--${grade}`}>{grade}</span>
                      <span className="rlCardTitle">{x.title}</span>
                    </div>
                    <div className="rlCardMain">
                      <div className="rlThumbCol">
                        {x.img ? (
                          <img className="rlThumb" src={x.img} alt={x.title} />
                        ) : (
                          <div className="rlThumb rlThumbPlaceholder" aria-hidden />
                        )}
                      </div>
                      <div className="rlCardPriceBlock">
                        <span className="rlMainPrice">{x.mainPrice}</span>
                        <div className="rlEstProfit">
                          Est Profit: <span className={isHighProfit ? "rlEstProfitVal rlEstProfitVal--high" : "rlEstProfitVal rlEstProfitVal--steady"}>{x.profit ?? "—"}</span>
                        </div>
                      </div>
                    </div>
                    <div className="rlCardBottom">
                      <span className="rlBottomPill rlBottomPill--act">Act Count: {x.unitsActive ?? 0}</span>
                      <span className="rlBottomPill rlBottomPill--sold">Sold Count: {x.unitsSold ?? 0}</span>
                      <span className="rlBottomPill rlBottomPill--dom">DOM: {x.soldDom ?? 0}</span>
                    </div>
                  </>
                );
                return x.vdp_url ? (
                  <a
                    key={x.id}
                    href={x.vdp_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rlCardRow rlRowLink"
                  >
                    <CardContent />
                  </a>
                ) : (
                  <article key={x.id} className="rlCardRow">
                    <CardContent />
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="rlList">
              {listings.map((x) => {
                const RowContent = () => (
                  <>
                    <div className="rlThumbCol">
                      {x.img ? (
                        <img className="rlThumb" src={x.img} alt={x.title} />
                      ) : (
                        <div className="rlThumb rlThumbPlaceholder" aria-hidden />
                      )}
                    </div>
                    <div className="rlMain">
                      <div className="rlVehicle">{x.title}</div>
                      <div className="rlMetricsLine">
                        <span className="rlMainPrice">{x.mainPrice}</span>
                        <span className="rlMileage">{x.mileage}</span>
                        <div className="rlPills">
                          <span className="rlPill">Active {x.unitsActive ?? 0}</span>
                          <span className="rlPill">Sold {x.unitsSold ?? 0}</span>
                          <span className="rlPill">DOM {x.soldDom ?? 0}</span>
                        </div>
                      </div>
                    </div>
                    <div className="rlRightCol">
                      <div className="rlRightProfitWrap">
                        <span className="rlRightProfitLabel">Profit</span>
                        <span className="rlRightPrice">{x.profit ?? "—"}</span>
                      </div>
                    </div>
                  </>
                );
                return x.vdp_url ? (
                  <a
                    key={x.id}
                    href={x.vdp_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rlRow rlRowLink"
                  >
                    <RowContent />
                  </a>
                ) : (
                  <article key={x.id} className="rlRow">
                    <RowContent />
                  </article>
                );
              })}
            </div>
          )}

          <footer className="rlFooter">
            <Link className="rlViewAll" to="/buy-signals">
              View All Listings <span className="rlChevron">›</span>
            </Link>
          </footer>
        </>
      )}
    </section>
  );
}

